import { Link } from "react-router-dom";
import { ArrowUp } from "lucide-react";

export const Footer = () => (
  <footer data-testid="footer-section" className="bg-[#f5f5f7] py-10">
    <div className="mx-auto max-w-5xl px-5 sm:px-6">
      <div className="grid grid-cols-2 gap-8 border-b border-black/10 pb-8 sm:grid-cols-4">
        <div>
          <p className="text-xs font-semibold text-[#1d1d1f]">Meranggi</p>
          <nav className="mt-3 flex flex-col gap-2" data-testid="footer-nav">
            {[
              ["About", "#about", "footer-link-about"],
              ["Services", "#services", "footer-link-services"],
              ["Location", "#location", "footer-link-location"],
              ["Contact", "#contact", "footer-link-contact"],
            ].map(([label, href, id]) => (
              <a
                key={id}
                href={href}
                data-testid={id}
                onClick={(e) => {
                  e.preventDefault();
                  window.__lenis?.scrollTo(href, { offset: -64, duration: 1.2 });
                }}
                className="w-fit text-xs text-[#6e6e73] transition-colors duration-200 hover:text-[#1d1d1f] hover:underline"
              >
                {label}
              </a>
            ))}
          </nav>
        </div>
        <div>
          <p className="text-xs font-semibold text-[#1d1d1f]">Contact</p>
          <div className="mt-3 flex flex-col gap-2">
            <a href="mailto:info@meranggi.com" data-testid="footer-email-link" className="w-fit text-xs text-[#6e6e73] hover:text-[#1d1d1f] hover:underline">
              info@meranggi.com
            </a>
            <a href="tel:+62361943614" data-testid="footer-phone-link" className="w-fit text-xs text-[#6e6e73] hover:text-[#1d1d1f] hover:underline">
              (0361) 943614
            </a>
          </div>
        </div>
        <div>
          <p className="text-xs font-semibold text-[#1d1d1f]">Legal</p>
          <div className="mt-3 flex flex-col gap-2">
            <Link to="/privacy" data-testid="footer-privacy-link" className="w-fit text-xs text-[#6e6e73] hover:text-[#1d1d1f] hover:underline">
              Privacy Policy
            </Link>
          </div>
        </div>
        <div className="flex items-start justify-end">
          <button
            data-testid="footer-top-link"
            onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
            aria-label="Back to top"
            className="flex h-9 w-9 items-center justify-center rounded-full bg-white text-[#6e6e73] transition-colors duration-200 hover:text-[#1d1d1f]"
          >
            <ArrowUp size={15} />
          </button>
        </div>
      </div>

      <div className="flex flex-col gap-3 pt-6 sm:flex-row sm:items-center sm:justify-between">
        <p data-testid="footer-copyright" className="text-xs text-[#86868b]">
          Copyright © {new Date().getFullYear()} CV Meranggi Jaya. All rights reserved.
        </p>
        <p className="text-xs text-[#86868b]">
          Jl. Raya Udayana, Blahbatuh, Gianyar, Bali 80581, Indonesia · meranggi.com
        </p>
      </div>
    </div>
  </footer>
);
